import client from './client';

export const recordProductView = async (productId: string) => {
    try {
        await client.post(`interactions/view/${productId}`);
    } catch (error) {
        console.error('Failed to record view', error);
    }
};

export const toggleProductLike = async (productId: string) => {
    const response = await client.post(`interactions/like/${productId}`);
    return response.data;
};

export const getProductInteractions = async (productId: string) => {
    const response = await client.get(`interactions/product/${productId}`);
    return response.data;
};
